module.exports = __webpack_public_path__ + "media/4x3/mp-c5eb7f23.svg";